import { baseApi } from "@/config/http-common";
import { filemanagerApi } from "@/config/http-filemanager";

class NomenclatureDataService {
  getAll(page: any): Promise<any> {
    return baseApi.get("/documents/nomenclature/list", {
      params: { page: page },
    });
  }

  get(id: any): Promise<any> {
    return baseApi.get(`/documents/nomenclature/view/${id}`);
  }

  create(data: any): Promise<any> {
    return baseApi.post("/documents/nomenclature/create", data);
  }

  update(id: any, data: any): Promise<any> {
    return baseApi.put(`/documents/nomenclature/update/${id}`, data);
  }

  delete(id: string): Promise<any> {
    return baseApi.delete(`/documents/nomenclature/${id}`);
  }

  uploadExcel(file: any): Promise<any> {
    return baseApi.post("/documents/nomenclature/import-excel", file, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

export default new NomenclatureDataService();
